// src/redux/reducers/ComCatRecruiteReducer.js

import {
    FETCH_WORKLOCATION_TYPE_REC_REQUEST,
    FETCH_WORKLOCATION_TYPE_REC_SUCCESS,
    FETCH_WORKLOCATION_TYPE_REC_FAILURE,
    SET_WORKLOCATION_COMPANY_REC_TYPE,
} from '../types';

const initialState = {
    loading: false,
    workLocation: [],
    selectedCategoryId: null, 
    error: '',
};

const workLocationTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case  FETCH_WORKLOCATION_TYPE_REC_REQUEST:
            return { ...state, loading: true };
        case  FETCH_WORKLOCATION_TYPE_REC_SUCCESS:
            return { ...state, loading: false, workLocation: action.payload, error: '' };
        case FETCH_WORKLOCATION_TYPE_REC_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SET_WORKLOCATION_COMPANY_REC_TYPE:
            return { ...state, selectedCategoryId: action.payload };
        default:
            return state;
    }
};

export default workLocationTypeReducer;
